import application from "stimulus_application";
import ImageController from "./image_controller";
import "./image.css";

application.register("image", ImageController);
